/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_Voice_Agents_Execute_Output7Inputs */

const en_svc_ai_voice_agents_execute_output7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Working voice agent`)
};

const ar_svc_ai_voice_agents_execute_output7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`وكيل صوتي يعمل`)
};

const bn_svc_ai_voice_agents_execute_output7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`কার্যকর ভয়েস এজেন্ট`)
};

const de_svc_ai_voice_agents_execute_output7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktionierender Sprachagent`)
};

const es_svc_ai_voice_agents_execute_output7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agente de voz funcional`)
};

const fr_svc_ai_voice_agents_execute_output7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agent vocal fonctionnel`)
};

const pt_svc_ai_voice_agents_execute_output7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Agente de voz funcional`)
};

const zh_svc_ai_voice_agents_execute_output7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`可用的语音助手`)
};

const tr_svc_ai_voice_agents_execute_output7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Çalışan sesli asistan`)
};

const ru_svc_ai_voice_agents_execute_output7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Рабочий голосовой агент`)
};

const pl_svc_ai_voice_agents_execute_output7 = /** @type {(inputs: Svc_Ai_Voice_Agents_Execute_Output7Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Działający agent głosowy`)
};

/**
* | output |
* | --- |
* | "Working voice agent" |
*
* @param {Svc_Ai_Voice_Agents_Execute_Output7Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_voice_agents_execute_output7 = /** @type {((inputs?: Svc_Ai_Voice_Agents_Execute_Output7Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_Voice_Agents_Execute_Output7Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_voice_agents_execute_output7(inputs)
	if (locale === "bn") return bn_svc_ai_voice_agents_execute_output7(inputs)
	if (locale === "de") return de_svc_ai_voice_agents_execute_output7(inputs)
	if (locale === "es") return es_svc_ai_voice_agents_execute_output7(inputs)
	if (locale === "fr") return fr_svc_ai_voice_agents_execute_output7(inputs)
	if (locale === "pt") return pt_svc_ai_voice_agents_execute_output7(inputs)
	if (locale === "zh") return zh_svc_ai_voice_agents_execute_output7(inputs)
	if (locale === "tr") return tr_svc_ai_voice_agents_execute_output7(inputs)
	if (locale === "ru") return ru_svc_ai_voice_agents_execute_output7(inputs)
	if (locale === "pl") return pl_svc_ai_voice_agents_execute_output7(inputs)
	return en_svc_ai_voice_agents_execute_output7(inputs)
});
export { svc_ai_voice_agents_execute_output7 as "svc_ai-voice-agents_EXECUTE_output" }